import classes from './WidgetEmail.module.css';

const WidgetEmail = ({ value, onChange, disabled = false }) => {
  return (
    <input
      type="email"
      className={classes.input}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      disabled={disabled}
    />
  );
};

export default WidgetEmail;
